export const CHANGE_MUSIC_PLAY_ACTION = 'CHANGE_MUSIC_PLAY_ACTION';

export const changeMusicPlayAction = play => ({
  type: CHANGE_MUSIC_PLAY_ACTION,
  play,
});



// WEBPACK FOOTER //
// ./src/actions/music-player.js